export default "__VITE_ASSET__2cxnRNnK__"